import React from "react";
import styled from "styled-components";

const fonSize = [18, 17, 16, 15, 14, 13, 12];
const fontWeight = [100, "normal", "bold", "bolder"];
export default function VizParagraph({ children, type = 5, weight = 2 }) {
  const Para = styled.span`
    color: #000000;
    font-size: ${fonSize[type - 1]}px;
    font-weight: ${fontWeight[weight - 1]};
  `;
  return <Para>{children}</Para>;
}
